<template>
  <RevDrawer
    background-color="mid"
    :name="MODAL_NAME"
    size="medium"
    :title="i18n(translations.drawerTitle)"
  >
    <template #body>
      <div class="flex flex-col gap-16">
        <RevCard class="bg-surface-default-hi p-24">
          <h2 class="heading-2 mb-16">{{ i18n(translations.howItWorks) }}</h2>
          <p class="body-1 mb-24">
            {{ i18n(translations.howItWorksContent1) }}
          </p>
          <p class="body-1">
            {{ i18n(translations.howItWorksContent2) }}
          </p>
        </RevCard>
        <RevCard class="bg-surface-default-hi p-24">
          <h2 class="heading-2 mb-16">{{ i18n(translations.tips) }}</h2>
          <ul class="body-1 list-disc pl-24">
            <li>{{ i18n(translations.tipsContent1) }}</li>
            <li>{{ i18n(translations.tipsContent2) }}</li>
            <li>{{ i18n(translations.tipsContent3) }}</li>
          </ul>
        </RevCard>
        <RevCard class="bg-surface-default-hi p-24">
          <h2 class="heading-2 mb-16">
            {{ i18n(translations.whyTakeAdvantage) }}
          </h2>
          <ul class="body-1 list-disc pl-24">
            <li>
              {{ i18n(translations.whyTakeAdvatageContent1) }}
            </li>
            <li>{{ i18n(translations.whyTakeAdvatageContent2) }}</li>
            <li>{{ i18n(translations.whyTakeAdvatageContent3) }}</li>
          </ul>
        </RevCard>
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAME } from './DealsInfoDrawer.constants'
import translations from './DealsInfoDrawer.translations'

const i18n = useI18n()
</script>
